import React from 'react';
import Swal from 'sweetalert2';
import styled from 'styled-components';
import api3001 from '../../services/api3001';

const DeleteButton = styled.button`
  margin: 2px;
  padding: 3px 6px;
  font-size: 11px;
  cursor: pointer;
  border-radius: 6px;
  background-color: transparent;
  white-space: nowrap;
  transition: background-color 0.3s ease, transform 0.2s ease;

  border: 1px solid #dc3545;
  color: #dc3545;

  &:hover {
    background-color: #dc3545;
    color: white;
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: 768px) {
    padding: 5px 10px;
  }

  @media (max-width: 480px) {
    padding: 4px 8px;
  }
`;

const ExcluirOrcamento = ({ orcamentoId, onDeleteSuccess }) => {
  const handleDelete = async () => {
    const result = await Swal.fire({
      title: 'Tem certeza?',
      text: 'Essa ação não pode ser desfeita.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, excluir!',
      cancelButtonText: 'Cancelar',
    });

    if (result.isConfirmed) {
      try {
        await api3001.delete(`/api/orcamento/${orcamentoId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        onDeleteSuccess(orcamentoId);
        Swal.fire('Excluído!', 'O orçamento foi excluído.', 'success');
      } catch (error) {
        console.error('Erro ao excluir o orçamento:', error);
        Swal.fire('Erro!', 'Ocorreu um erro ao excluir o orçamento.', 'error');
      }
    }
  };

  return <DeleteButton onClick={handleDelete}>Excluir</DeleteButton>;
};

export default ExcluirOrcamento;
